module.exports = __webpack_public_path__ + "img/background_2.e4270c6d.png";